import PropTypes from 'prop-types';

export const DropDownTipoUsuario = ({ userTypeIds, handleTipoUsuarioChange, localTipoUsuario, tiposUsuario, currentUserType }) => {
    return (
        <div className="col-12 col-sm-6 mt-2">
            <div className="form-group">
                <label htmlFor="tipoUsuarioUserEdit" className="label-oscura">Tipo Usuario</label>
                <div style={{ position: 'relative' }}>
                    <select
                        id="tipoUsuarioUserEdit"
                        className="form-control form-select"
                        style={{
                            height: '42px',
                            borderRadius: '10px',
                            appearance: 'none',
                            WebkitAppearance: 'none',
                            MozAppearance: 'none',
                            backgroundColor: '#fff',
                            border: '1px solid rgba(15, 23, 42, 0.12)',
                            paddingRight: '40px',
                            fontSize: '0.95rem',
                            color: '#1e293b',
                            cursor: 'pointer',
                            boxShadow: 'none'
                        }}
                        value={localTipoUsuario || ""}
                        onChange={(e) => handleTipoUsuarioChange({ value: Number.parseInt(e.target.value) })}
                        name="localTipoUsuario"
                    >
                        <option value="">Seleccione...</option>
                        {tiposUsuario?.filter(tipo => currentUserType === userTypeIds.isAdminMod ? true : (tipo.id === userTypeIds.isSellerAdmin || tipo.id === userTypeIds.isSeller))
                            .map(tipo => (
                                <option key={tipo.id} value={tipo.id}>{tipo.descripcion}</option>
                            ))}
                    </select>
                    <i
                        className="mdi mdi-chevron-down"
                        style={{
                            position: 'absolute',
                            right: '15px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            pointerEvents: 'none',
                            color: '#6c757d',
                            fontSize: '20px'
                        }}
                    />
                </div>
            </div>
        </div>
    );
}
DropDownTipoUsuario.propTypes = {
    userTypeIds: PropTypes.shape({
        isAdminMod: PropTypes.number,
        isSellerAdmin: PropTypes.number,
        isSeller: PropTypes.number
    }),
    localTipoUsuario: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    tiposUsuario: PropTypes.array,
    currentUserType: PropTypes.number,
    handleTipoUsuarioChange: PropTypes.func
}